// 一次点击可能触发多个接口，短时间内的请求共用同一个操作事件。
const ACTION_EVENT_TTL = 1000;

let activeActionEvent = null;
let clearTimer = null;

// 生成前端操作事件ID，旧浏览器不支持 randomUUID 时使用时间戳兜底。
export const createActionEventId = () => {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

// 保存当前点击事件，供 axios 请求拦截器关联后续业务请求。
export const setActiveActionEvent = (eventId, actionKey) => {
  activeActionEvent = {
    eventId,
    actionKey,
    expiresAt: Date.now() + ACTION_EVENT_TTL
  };

  if (clearTimer) {
    window.clearTimeout(clearTimer);
  }

  clearTimer = window.setTimeout(() => {
    activeActionEvent = null;
    clearTimer = null;
  }, ACTION_EVENT_TTL);
};

// 获取仍在有效时间内的点击事件，过期后不再关联请求。
export const getActiveActionEvent = () => {
  if (!activeActionEvent || activeActionEvent.expiresAt < Date.now()) {
    activeActionEvent = null;
    return null;
  }

  return activeActionEvent;
};
